import React, { FC } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import ClientDownload from '../../../components/common/ClientDownload'
import { Link, useParams } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { LangValue } from '../../../../states/types/common'
import { URL } from '../../../constants/url'

const Index: FC = () => {
  const { t } = useTranslation()
  const { language } = useParams<{ language: LangValue }>()

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 個人設定 - ${t("client.download.title")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        <Link
          to={setPath(URL.SETTING_PERSONAL.path, language)}
        >
          個人設定
        </Link>
        &nbsp;&gt;&nbsp;
        {t("client.download.title")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("client.download.title")}
        </h1>
      </section>
      <section className="page_contents content-area">
        <ClientDownload />
      </section>
    </section>
  )
}

export default Index
